// https://stackoverflow.com/a/35306050/4032871
const objIdMap = new WeakMap();
let objectCount = 0;
export default function objectId(object) {
    if (!objIdMap.has(object)) objIdMap.set(object, ++objectCount);
    return objIdMap.get(object);
}
